const segmenter =
    typeof Intl.Segmenter === 'function'
        ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
        : null;
const emojiPattern = /\p{Extended_Pictographic}|\p{Regional_Indicator}|^[0-9#*]\uFE0F?\u20E3/u;

export function splitLeadingEmoji(value: string): { emoji?: string; text: string } {
    if (!segmenter) return { text: value };

    const trimmed = value.trim();
    const [first] = segmenter.segment(trimmed);

    if (!first || !emojiPattern.test(first.segment)) {
        return { text: value };
    }

    return {
        emoji: first.segment,
        text: trimmed.slice(first.segment.length).trimStart(),
    };
}

/**
 * Split text into the characters a reader sees, ignoring whitespace.
 *
 * Without Intl.Segmenter, the text comes back whole rather than split by code
 * point, which would break sequences like skin-toned emoji into pieces.
 */
export function splitGraphemes(value: string): string[] {
    if (!segmenter) return value.trim() ? [value.trim()] : [];

    return Array.from(segmenter.segment(value), ({ segment }) => segment).filter((segment) =>
        segment.trim(),
    );
}
